import React, { Component } from "react";
import { Alert } from "react-bootstrap";

import LddDescription from "./LDD/LddDescription";
import OpenVPNDescription from "./OpenVPN/OpenVPNDescription";
import HaproxyDescription from "./Haproxy/HaproxyDescription";

import "./style.css";

class InteractionLWOCrypt extends Component {
    constructor() {
        super();

    }

    render() {
        return (
            <Alert style={{ width: '100%', cursor: 'pointer', }} variant="light">
                <div onClick={this.props.blockInteractionLWOCryptIsOpen ? this.props.closeBlockInteractionLWOCrypt : this.props.openBlockInteractionLWOCrypt}
                    style={{ display: "flex", borderBottom: this.props.blockInteractionLWOCryptIsOpen ? "1px solid #e3e3e3" : null, height: this.props.blockInteractionLWOCryptIsOpen ? "70px" : null /*cursor: "pointer"*/ }}>
                    <div style={{ width: "80%" }}>
                        <div style={{ color: "black" }}>Взаимодействие LWOCrypt c OpenVPN, Haproxy, LDDClient</div>

                    </div>
                    <div style={{ width: "20%" }}>
                        <b style={{ color: "black", float: "right" }}>
                            {this.props.blockInteractionLWOCryptIsOpen ?
                                <div >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="4" fill="none"><path d="M12.25.438H1.75a.881.881 0 00-.875.875v.875c0 .492.383.874.875.874h10.5a.881.881 0 00.875-.874v-.876a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg>
                                </div> :
                                <div><svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" fill="none"><path d="M12.25 5.438H8.312V1.5a.9.9 0 00-.874-.875h-.875a.881.881 0 00-.875.875v3.938H1.75a.881.881 0 00-.875.875v.875c0 .492.383.875.875.875h3.938V12c0 .492.382.875.875.875h.875A.881.881 0 008.313 12V8.062h3.937a.881.881 0 00.875-.874v-.875a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg></div>
                            }
                        </b>
                    </div>

                </div>
                {
                    this.props.blockInteractionLWOCryptIsOpen ?
                        <div className="sp-lwocrypt-block">
                            <LddDescription
                                blockLddDescriptionIsOpen={this.props.blockLddDescriptionIsOpen}
                                openBlockLddDescription={this.props.openBlockLddDescription}
                                closeBlockLddDescription={this.props.closeBlockLddDescription}
                            />
                            <div style={{ width: "100%", backgroundColor: "#e3e3e3", height: "1px" }} />
                            <OpenVPNDescription
                                blockOpenVPNDescriptionIsOpen={this.props.blockOpenVPNDescriptionIsOpen}
                                openBlockOpenVPNDescription={this.props.openBlockOpenVPNDescription}
                                closeBlockOpenVPNDescription={this.props.closeBlockOpenVPNDescription}
                            />
                            <div style={{ width: "100%", backgroundColor: "#e3e3e3", height: "1px" }} />
                            <HaproxyDescription
                                blockHaproxyDescriptionIsOpen={this.props.blockHaproxyDescriptionIsOpen}
                                openBlockHaproxyDescription={this.props.openBlockHaproxyDescription}
                                closeBlockHaproxyDescription={this.props.closeBlockHaproxyDescription}
                            />
                        </div> : null
                }

            </Alert>
        );
    }
}

export default InteractionLWOCrypt;
